module.exports = __webpack_public_path__ + "static/media/jetpure-logo.d40f5329.jpg";